module.exports = __webpack_public_path__ + "static/media/play.0c7aca14.svg";